export default __webpack_public_path__ + "static/media/netlify.c779369f.svg";